import React from 'react'
import PropTypes from 'prop-types'

const Empty = ({ message }) => {
  return (
    <div className='col-12 my-2 txt-font-body txt-subtitle color-ui-2' style={{ textAlign: 'center' }}>
      <h5>{message}</h5>
    </div>
  )
}

Empty.propTypes = {
  message: PropTypes.string
}

export default Empty



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Shared/Empty.js